import { all } from 'redux-saga/effects';
import { authSaga } from './authSaga';
import { demographicsSaga } from './demographicsSaga';
import { menuEnhancementSaga } from './menuEnhancementSaga';
import { reviewAnalysisSaga } from './reviewAnalysisSaga';
import { competitorPromotionSaga } from './competitorPromotionSaga';
import { competitorsSaga } from './competitorsSaga';
import { upcomingEventsSaga } from './upcomingEventsSaga';
import { menuItemsSaga } from './menuItemsSaga';
import eventUploadSaga from './eventUploadSaga';
import { scheduledCampaignsSaga } from './scheduledCampaignsSaga';
import campaignGenerationSaga from './campaignGenerationSaga';
import generatedIdeasSaga from './generatedIdeasSaga';
import workflowTriggerSaga from './workflowTriggerSaga';
import integrationsSaga from './integrationsSaga';
import { cloverSaga } from './cloverSaga';
import { campaignIdeasSaga } from './campaignIdeasSaga';
import { contentGenerationWorkflowSaga } from './contentGenerationWorkflowSaga';
import { watchCampaignPosting } from './campaignPostingSaga';
import { restaurantSaga } from './restaurantSaga';
import { socialMediaPostsSaga } from './socialMediaPostsSaga';
import pexelsSaga from './pexelsSaga';
import imageUploadSaga from './imageUploadSaga';
import campaignCreationSaga from './campaignCreationSaga';
import mediaCaptionSaga from './mediaCaptionSaga';
import campaignAnalyticsSaga from './campaignAnalyticsSaga';
import campaignPostsAnalyticsSaga from './campaignPostsAnalyticsSaga';
import campaignsSaga from './campaignsSaga';
import facebookPagesSaga from './facebookPagesSaga';
import customersSaga from './customersSaga';
import campaignScheduleSaga from './campaignScheduleSaga';
import { templatesLibrarySaga } from './templatesLibrarySaga';

export default function* rootSaga() {
  yield all([
    authSaga(),
    demographicsSaga(),
    menuEnhancementSaga(),
    reviewAnalysisSaga(),
    competitorPromotionSaga(),
    competitorsSaga(),
    upcomingEventsSaga(),
    menuItemsSaga(),
    eventUploadSaga(),
    scheduledCampaignsSaga(),
    campaignGenerationSaga(),
    generatedIdeasSaga(),
    workflowTriggerSaga(),
    integrationsSaga(),
    cloverSaga(),
    campaignIdeasSaga(),
    contentGenerationWorkflowSaga(),
    watchCampaignPosting(),
    restaurantSaga(),
    socialMediaPostsSaga(),
    pexelsSaga(),
    imageUploadSaga(),
    campaignCreationSaga(),
    mediaCaptionSaga(),
    campaignAnalyticsSaga(),
    campaignPostsAnalyticsSaga(),
    campaignsSaga(),
    facebookPagesSaga(),
    customersSaga(),
    campaignScheduleSaga(),
    templatesLibrarySaga(),
    // Add other sagas here as you create them
  ]);
}
